// @flow
import liftNodes from 'utils/GraphQL/typedLiftNodes'
import {
  makeValue,
  makeValues,
  pickChildrenOfType,
} from 'components/proposals/Part/shared/fetchFieldsFromChange'
import Value from '../ui/Value'
import type {Change, LinkedRole} from './types'

function liftAccountabilities(body: Object, linkedRole: ?LinkedRole): $ReadOnlyArray<Value> {
  const originalAccountabilityValues = (
    liftNodes(linkedRole?.originalRole?.accountabilities)
      .map((acc) => ({...acc, isProtected: true}))
      .map(makeValue)
  )

  const linkedRoleAccountabilities = (
    makeValues(
      liftNodes(linkedRole?.accountabilities),
      pickChildrenOfType('Accountability', body),
    )
  )

  return originalAccountabilityValues
    .concat(linkedRoleAccountabilities)
}

function liftDomains(body: Object, linkedRole: ?LinkedRole): $ReadOnlyArray<Value> {
  const originalDomainValues = (
    liftNodes(linkedRole?.originalRole?.domains)
      .map((acc) => ({...acc, isProtected: true}))
      .map(makeValue)
  )

  const linkedRoleDomains = (
    makeValues(
      liftNodes(linkedRole?.domains),
      pickChildrenOfType('Domain', body),
    )
  )

  return originalDomainValues
    .concat(linkedRoleDomains)
}

function fetchFieldsFromChange({availableRoles, linkedRole, ...props}: Change): any {
  const body = JSON.parse(props.command)

  return {
    ...props,
    linkedRole,
    destroy: body.destroy,
    availableRoles: liftNodes(availableRoles),
    accountabilities: liftAccountabilities(body, linkedRole),
    domains: liftDomains(body, linkedRole),
  }
}

export default fetchFieldsFromChange
